module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAALxJREFUSEtjZC47Ev/v378JDIwMAgz4wYP/jP8bGLrsFyIrI1U/I2PpofsMDAwKBCyDSX/4320niKyWVP0gC/8TaRlY2f9uO0Y0C0nSP2ohRmiPBimhBDgSEk3JofdElDLQkPr/4H+3vSJKPiRRPyND6f4ERgamegYGRvylzf//H/7/Yyxk6LNbgBJPJOpHKTUIRTg15EctpEYoopjBSGp9NlofEoqDkVC0jTYx0FLBaI1POFuQWJ8NufoQAIKYzluegzzTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fangge.png
// module id = nhHz
// module chunks = 1